import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../../../api-config/axiosInstance";
import { Box, Card } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./verifyEmail.css";

// Styled SectionStyle as in Login.tsx
const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 980,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
}));

const VerifyEmail: React.FC = () => {
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const calledRef = useRef(false);

  // Extract token from query params
  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  // Remove token from URL after extracting
  useEffect(() => {
    if (token) {
      window.history.replaceState({}, document.title, "/verify-email-pms");
    }
  }, [token]);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;
    const verify = async () => {
      setLoading(true);
      if (!token) {
        setMessage("No token provided for verification.");
        setIsError(true);
        setLoading(false);
        return;
      }
      try {
        const response = await api.get(`/verify-email-pms?token=${token}`);
        const { msg, status } = response.data;
        if (status === 200) {
          if (msg === "Your email is already verified.") {
            setMessage("Your email is already verified. You can now log in to your account.");
          } else {
            setMessage("Your email has been verified successfully! You can now log in to your account.");
          }
          setIsError(false);
        } else {
          setMessage(msg || "Verification failed.");
          setIsError(true);
        }
      } catch (err: any) {
        setMessage("Verification failed.");
        setIsError(true);
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, [token]);

  // if (loading) {
//     return <RotatingLoader />;
//   }

  return (
    <div className="verify-email-wrapper">
      <SectionStyle className="verify-email-container">
        <div className="verify-image">
          <img
            src="/static/images/minh-pham-7pCFUybP_P8-unsplash.jpg"
            alt="login"
          />
        </div>

        <div className="verify-content">
          <Box
            component="img"
            src="/static/images/newlogo1.png"
            sx={{
              width: "180px",
              height: "auto",
              display: "block",
              margin: "4px auto -4px",
              alignItems: "center",
            }}
          />
          <h2 className="verify-email-h2">Email Verification</h2>
          <div className="verify-email-content">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
          <a href="/login" className="verify-login-btn">
            Go to Login
          </a>
        </div>
      </SectionStyle>
    </div>
  );
};

export default VerifyEmail;